// extracted by mini-css-extract-plugin
export default {"container":"container_wy_8J","title":"title_sgNla"};